import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="120"
    height="138"
    viewBox="0 0 120 138"
    fill="none"
  >
    <path
      d="M48.8168 24.8745C51.4816 24.4363 53.2867 21.9208 52.8485 19.2559C52.4103 16.5911 49.8948 14.786 47.2299 15.2242C44.5651 15.6624 42.76 18.1779 43.1982 20.8427C43.6364 23.5076 46.1519 25.3127 48.8168 24.8745Z"
      fill="#E8C8B3"
    />
    <path
      d="M40.1029 22.5906C42.2118 22.2438 44.3722 22.749 46.1087 23.9951L54.6338 30.1125L53.0146 35.3344L48.999 33.5169L47.7766 41.1513L36.9199 42.9365L39.3649 27.6676L33.7301 31.0719L32.9367 26.2467L37.2431 23.645C38.1206 23.1148 39.0912 22.7569 40.1029 22.5906Z"
      fill="#04957C"
    />
    <path
      d="M61.1363 47.0555L61.1842 47.3465C61.3413 48.3028 61.1915 49.2843 60.7563 50.1502L57.9208 55.792L53.9577 63.6742L49.9421 61.8567L53.1942 53.6531L55.1963 48.6036L44.3397 50.3888C43.7061 50.4932 43.058 50.4717 42.4327 50.3255C41.8073 50.1794 41.2169 49.9114 40.6951 49.537C40.1733 49.1626 39.7304 48.6891 39.3917 48.1434C39.053 47.5978 38.8252 46.9908 38.7212 46.357L38.1261 42.7382L47.7764 41.1513L54.2046 42.5722L57.602 43.3237C58.4966 43.5211 59.3116 43.9822 59.9416 44.6474C60.5716 45.3126 60.9878 46.1514 61.1363 47.0555Z"
      fill="#E8C8B3"
    />
    <path
      d="M45.5462 50.1904L42.9191 56.8169L41.4469 60.0695C41.2185 60.5749 40.9054 61.0375 40.5212 61.4374L33.7452 68.5061L28.4112 74.0693L25.4036 70.8472L35.8797 59.2133L37.3563 55.0927L40.126 47.3649L45.5462 50.1904Z"
      fill="#E8C8B3"
    />
    <path
      d="M47.2958 66.1589C47.2433 66.4869 47.2927 66.823 47.4372 67.1221C47.5817 67.4212 47.8144 67.6687 48.104 67.8314L53.9417 71.1103L54.7827 70.972C55.5195 70.8508 56.1779 70.442 56.6131 69.8354C57.0484 69.2288 57.2249 68.4741 57.1038 67.7374C57.0136 67.189 56.7631 66.6796 56.3839 66.2732L53.9578 63.6742L49.9423 61.8566C49.2402 62.3648 48.6452 63.0063 48.1911 63.7445C47.737 64.4827 47.4328 65.3031 47.2958 66.1589Z"
      fill="#E4E4E2"
    />
    <path
      d="M28.4111 74.0693L29.0061 77.6882L30.074 80.1592C30.1846 80.415 30.2354 80.6926 30.2225 80.971C30.2097 81.2494 30.1336 81.5211 30.0001 81.7657C29.8665 82.0102 29.6789 82.2211 29.4517 82.3823C29.2244 82.5436 28.9634 82.6509 28.6884 82.6961L26.1807 83.1084L23.173 79.8863L21.8301 76.3225C21.5844 75.6706 21.56 74.956 21.7606 74.2888C21.9612 73.6216 22.3757 73.0389 22.9401 72.6305L25.4035 70.8472L28.4111 74.0693Z"
      fill="#E4E4E2"
    />
    <path
      d="M33.7301 31.072L25.9357 36.411C25.5054 36.6853 24.9926 36.8004 24.4864 36.7363C23.9801 36.6722 23.5123 36.4329 23.164 36.0599C22.9471 35.8273 22.7836 35.5502 22.6849 35.2479C22.5862 34.9456 22.5547 34.6254 22.5926 34.3096C22.6304 33.9939 22.7367 33.6902 22.9041 33.4198C23.0714 33.1494 23.2958 32.9187 23.5615 32.744L32.9367 26.2468L33.7301 31.072Z"
      fill="#E8C8B3"
    />
    <path
      d="M54.6752 30.0646L59.8206 23.9846C60.2496 23.4887 60.8485 23.1712 61.4997 23.0942C62.1508 23.0173 62.8072 23.1865 63.34 23.5686C63.6309 23.7774 63.876 24.0435 64.0604 24.3504C64.2447 24.6574 64.3644 24.9988 64.4121 25.3536C64.4598 25.7085 64.4345 26.0693 64.3377 26.4141C64.2409 26.7588 64.0748 27.0801 63.8494 27.3583L57.8634 34.8342C57.3117 35.5148 56.5208 35.9589 55.6524 36.0756C54.7841 36.1923 53.904 35.9728 53.1922 35.4619C53.1404 35.4248 53.1017 35.3723 53.0814 35.312C53.0612 35.2516 53.0604 35.1864 53.0793 35.1256L54.6148 30.1733C54.6273 30.1333 54.6478 30.0963 54.6752 30.0646Z"
      fill="#E8C8B3"
    />
    <path
      d="M45.5461 50.1904L42.919 56.8169L37.6971 55.1978L37.3562 55.0928L40.1259 47.365L45.5461 50.1904Z"
      fill="#F3AF3E"
    />
    <path
      d="M51.1428 12.5279C51.0935 12.5445 51.0453 12.5627 50.9967 12.5812C50.9196 11.5123 50.4932 10.4984 49.7831 9.69579C49.073 8.89314 48.1187 8.34624 47.0672 8.13935C46.0157 7.93246 44.9253 8.07707 43.9641 8.55088C43.0028 9.0247 42.2241 9.80143 41.7478 10.7614C41.2714 11.7214 41.124 12.8114 41.3281 13.8634C41.5323 14.9155 42.0767 15.8712 42.8775 16.5834C43.6783 17.2956 44.691 17.7247 45.7597 17.8046C46.8284 17.8845 47.8937 17.6108 48.7915 17.0257C48.8058 17.0752 48.8207 17.1248 48.8373 17.1741C49.0688 17.8615 49.4989 18.4649 50.0733 18.9078C50.6477 19.3508 51.3405 19.6135 52.0642 19.6627C52.7879 19.7119 53.5099 19.5454 54.139 19.1842C54.768 18.8231 55.2759 18.2835 55.5983 17.6337C55.9207 16.9839 56.0431 16.2532 55.9502 15.5338C55.8573 14.8144 55.5531 14.1387 55.0762 13.5922C54.5992 13.0457 53.971 12.6529 53.2708 12.4635C52.5706 12.274 51.83 12.2965 51.1426 12.528L51.1428 12.5279Z"
      fill="#533222"
    />
    <path
      d="M57.9209 55.792L53.9578 63.6742L49.9423 61.8566L53.1943 53.6531L57.9209 55.792Z"
      fill="#DC4D41"
    />
    <path
      d="M33.7451 68.5061L28.4111 74.0694L25.4035 70.8472L30.6416 65.0303L33.6492 68.2524L33.7451 68.5061Z"
      fill="#DC4D41"
    />
    <path
      d="M54.2046 42.5722L52.7838 49.0003L44.3397 50.3888C43.7061 50.4932 43.058 50.4717 42.4327 50.3255C41.8073 50.1794 41.2169 49.9114 40.6951 49.537C40.1733 49.1626 39.7304 48.6891 39.3917 48.1434C39.053 47.5978 38.8252 46.9908 38.7212 46.357L38.1261 42.7382L47.7764 41.1513L54.2046 42.5722Z"
      fill="#FBB540"
    />
    <rect x="1" y="107" width="42" height="30" rx="3" fill="#B28E66" />
    <path
      d="M1 110C1 108.343 2.34315 107 4 107H40C41.6569 107 43 108.343 43 110V114.2H1V110Z"
      fill="#8D6C46"
    />
    <rect
      x="68"
      y="74.4375"
      width="51"
      height="33.5625"
      rx="3"
      fill="#B9956E"
    />
    <path
      d="M68 77.4375C68 75.7806 69.3431 74.4375 71 74.4375H116C117.657 74.4375 119 75.7806 119 77.4375V82.4925H68V77.4375Z"
      fill="#0CB746"
    />
  </SvgIcon>
));
